import React, { useCallback, memo } from 'react';
import { Select } from '@leasequery/lq.react-component-library';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import { REPORT_CURRENCY_SELECT_OPTIONS } from '../../../constants';
import { ClientCustomCalendarModel, ReportCurrency } from '../../../models';
import * as Styled from './styled';
import { ReportTypeSetting } from '../../../models/reportTypeSetting';
import { Icon } from '../../../components';
import { CurrencySelectorWrapper } from '../../../components';

interface ReportSettingROUAssetsProps {
  onChange: (updatedValue: ReportSettingROUAssetsState) => void;
  reportSettingState: ReportSettingROUAssetsState;
  reportTypeSetting: ReportTypeSetting;
  customCalendarSettings?: ClientCustomCalendarModel;
  isAllowPIT: boolean;
}

export interface ReportSettingROUAssetsState {
  selectedCurrency: SelectOption<ReportCurrency>;
  reportEndDate: string;
  isValid: boolean;
}

function ReportSettingROUAssets({
  onChange,
  reportSettingState,
}: ReportSettingROUAssetsProps): JSX.Element {
  return (
    <>
      <CurrencySelectorWrapper>
        <Styled.DropdownBar>
          <div>
            <Icon name="currency" />
          </div>
          <Select
            placeholder="Local currency"
            label="Currency"
            name="currency"
            options={REPORT_CURRENCY_SELECT_OPTIONS}
            onChange={useCallback(
              (option: SelectOption<ReportCurrency>): void => {
                onChange({
                  ...reportSettingState,
                  selectedCurrency: option,
                });
              },
              [onChange, reportSettingState],
            )}
            value={reportSettingState.selectedCurrency}
          />
        </Styled.DropdownBar>
      </CurrencySelectorWrapper>
      <Styled.Line />
    </>
  );
}

export default memo(ReportSettingROUAssets);
